._bannerWrapper_d2en5_1 {
  margin-bottom: 24px; }

._banner_d2en5_1 {
  width: 100%; }

._titleContainer_d2en5_7 {
  text-align: center;
  padding: 0 24px;
  margin-bottom: 6px; }

._title_d2en5_7 {
  margin-bottom: 6px;
  display: block; }

._promotionalList_d2en5_16 {
  padding: 18px 24px 12px;
  text-align: center; }

._welcomeSection_d2en5_20 ._promotionalList_d2en5_16 svg {
  align-self: flex-start;
  margin-right: 13px;
  margin-top: 4px;
  fill: #60bc57; }

._numericListWrapper_d2en5_26 {
  display: flex;
  justify-content: center;
  padding: 18px 24px 12px; }

._numericListItem_d2en5_31 {
  display: flex;
  align-items: flex-start;
  margin-bottom: 12px; }

._numericListItemValue_d2en5_36 {
  padding-left: 0.5em; }
